var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilm01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "film-01",
    clipPath: "url(#clip0_2245_1306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66675 10.0001H18.3334M1.66675 5.83341H5.83341M14.1667 5.83341H18.3334M1.66675 14.1667H5.83341M14.1667 14.1667H18.3334M5.83341 18.3334V1.66675M14.1667 18.3334V1.66675M5.66675 18.3334H14.3334C15.7335 18.3334 16.4336 18.3334 16.9684 18.0609C17.4388 17.8212 17.8212 17.4388 18.0609 16.9684C18.3334 16.4336 18.3334 15.7335 18.3334 14.3334V5.66675C18.3334 4.26662 18.3334 3.56655 18.0609 3.03177C17.8212 2.56137 17.4388 2.17892 16.9684 1.93923C16.4336 1.66675 15.7335 1.66675 14.3334 1.66675H5.66675C4.26662 1.66675 3.56655 1.66675 3.03177 1.93923C2.56137 2.17892 2.17892 2.56137 1.93923 3.03177C1.66675 3.56655 1.66675 4.26662 1.66675 5.66675V14.3334C1.66675 15.7335 1.66675 16.4336 1.93923 16.9684C2.17892 17.4388 2.56137 17.8212 3.03177 18.0609C3.56655 18.3334 4.26662 18.3334 5.66675 18.3334Z",
    stroke: "#1672BA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2245_1306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm01);
export default __webpack_public_path__ + "static/media/film-01.55ce1d4ca8b3b5043bf71065d9d944c3.svg";
export { ForwardRef as ReactComponent };